import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	fetch: false,
	addFetch: false,
	succes: false,
};

const walletsSlice = createSlice({
	name: "wallets",
	initialState,
	reducers: {
		drop: () => initialState,
		get: (state) => {
			state.fetch = true;
		},
		set: (state, action) => {
			state.fetch = false;
			state.list = action.payload;
		},
		addReq: (state) => {
			state.addFetch = true;
		},
		addRes: (state, action) => {
			state.addFetch = false;
			state.succes = action.payload;
		},
		deleteWallet: () => {},
	},
});

export const walletsActions = walletsSlice.actions;
export const walletReducer = walletsSlice.reducer;
